// サーバーのエラーコード（#2235 api-endpoints.md）を画面文言へ変換する（ui-design.md 6）。
// 403（ロール不足）は共通の axios interceptor が処理するため、ここでは扱わない。
const RISK_ASSESSMENT_MESSAGE = "リスクアセスメントの入力が必要です。もう一度入力してください。";

export const GENERIC_ERROR_MESSAGE = "報告に失敗しました。時間をおいて再度お試しください。";

export const ERROR_MESSAGES: Record<string, string> = {
  not_assigned: "この相談の担当ではないため報告できません。",
  operation_period_expired:
    "報告可能な期間（相談対応完了から72時間）を過ぎています。運営にお問い合わせください。",
  risk_assessment_required: RISK_ASSESSMENT_MESSAGE,
  risk_assessment_invalid: RISK_ASSESSMENT_MESSAGE,
  supplement_note_too_long: "運営への補足は2,000文字以内で入力してください。",
  invalid_consultable_type: GENERIC_ERROR_MESSAGE,
  not_found: "対象の相談が見つかりません。"
};

export const extractErrorCode = (error: unknown): string | null => {
  const response = (error as { response?: { data?: { error?: string } } })?.response;

  return response?.data?.error ?? null;
};

export const resolveErrorMessage = (error: unknown): string => {
  const code = extractErrorCode(error);

  return (code && ERROR_MESSAGES[code]) || GENERIC_ERROR_MESSAGE;
};

// GET /new が reportable: false を返したときのスナックバー文言。
export const deniedReasonMessage = (reason: string | null): string =>
  (reason && ERROR_MESSAGES[reason]) || GENERIC_ERROR_MESSAGE;
